import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=4c8a68ec&"
import script from "./CheckboxList.vue?vue&type=script&lang=js&"
export * from "./CheckboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports